
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Switch, Input, MainModal, Form, CheckCircleOutlined, CloseCircleOutlined, ExclamationCircleOutlined, Button, Tag, Select, Row, Col, Modal, Typography, message, ProTableOt, useProTableOt, Tabs, Spin, Skeleton } from './../ui/ot'
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement } from 'chart.js';
import { Bar, Pie } from 'react-chartjs-2';
import { useRef } from 'react';
import styled from "styled-components"
import { useStaffStatisticsGender } from './controllers/staff_statistics_gender_controller'
import { useStaffStatisticsDepartment } from './controllers/staff_statistics_department_controller'
import { useStaffStatisticsRole } from './controllers/staff_statistics_role_controller'
import { useGender } from './controllers/gender_controller'
import { useStaff } from './controllers/staff_controller'
import { useDepartment } from './controllers/department_controller'
import { useDepartmentDepth } from './controllers/department_depth_controller'
import DepartmentRole from '../organization_structure/components/DepartmentRole';
import { createContext } from 'react';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import BindLineId from '../login/BindLineId';
import { PropertyJson } from './DepartmentRoleManagement';

const { confirm } = Modal;
const LanguageContext = createContext(null)
const Staff = ({
    keyPrefix = "organization_structure.staff",
    onSelect = () => { },
    defaultSelectedKeys = [],
    defaultSelectedInfo = [],
    staff_id = null,
    show_tab_bar = true,
    show_chart = false,
    show_header_title = true,
    show_tool_bar = true,
}) => {
    const [form] = Form.useForm()
    const actionRef = useRef(null)
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectedKeys)
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectedInfo)
    const [extra_columns, set_extra_columns] = useState([]);
    const [total, set_total] = useState(1);
    const [title, setTitle] = useState();
    const [edit, setEdit] = useState(false);
    const [open, setOpen] = useState(false);
    const setModalOpen = setOpen
    const [color, setColor] = useState('d65b77');
    const [editcard, setEditCard] = useState({});
    const [messageApi, contextHolder] = message.useMessage();
    const [modalLoading, setModalLoading] = useState(false)
    const [loading, setLoading] = useState(false)
    const [axiosMode, setAxiosMode] = useState("get")
    const [force_reload, set_force_reload] = useState(0)
    const [data, setData] = useState([]);
    const [roleOption, setRoleOption] = useState([]);
    const [departmentOption, setDepartmentOption] = useState([]);
    const [departmentData, setDepartmentData] = useState([]);
    const [roleData, setRoleData] = useState([]);
    const [selectDepartmentId, setSelectDepartmentId] = useState();
    const [selectRoleId, setSelectRoleId] = useState();
    const tabDepartmentId = useRef(undefined)
    const departmentId = useRef()
    const roleId = useRef()
    const defaultColumns = [
        {
            title: '人員編號',
            key: 'staff_serial_name',
            dataIndex: 'staff_serial_name',
            align: 'center',
        },
        {
            title: '系統帳號',
            key: 'serial_name',
            dataIndex: 'serial_name',
            align: 'center',
        },
        {
            title: '人員姓名',
            key: 'staff_name',
            dataIndex: 'staff_name',
            align: 'center',
        },
        {
            title: '人員英文名',
            key: 'staff_english_name',
            dataIndex: 'staff_english_name',
            align: 'center',
        },
        {
            title: '性別',
            key: 'gender_name',
            dataIndex: 'gender_name',
            align: 'center',
        },
        {
            title: '額外資訊',
            key: 'property_json',
            dataIndex: 'property_json',
            align: 'center',
            render: (text) => <>
                <Row>
                    {Object.keys(text).map(item => <Col span={24}>{item}：{text[item]}</Col>)}
                </Row>
            </>
        },
        {
            title: '單位 - 職稱',
            key: 'department_role',
            dataIndex: 'department_role',
            align: 'center',
            render: (text, record, index) => (
                record.user_department_role_data && record.user_department_role_data.map((item) => (
                    <Col span={24}><Tag color="geekblue">
                        {
                            item?.department_name_language_data !== undefined
                                ? (item?.role_name_language_data !== undefined
                                    ? (item?.department_name_language_data[0]?.language_culture_value + ' - ' + item?.role_name_language_data[0]?.language_culture_value)
                                    : item?.department_name_language_data[0]?.language_culture_value)
                                : ''
                        }
                    </Tag></Col>
                ))
            )
        },
        {
            title: 'Line通知',
            key: 'have_line_token',
            dataIndex: 'have_line_token',
            align: 'center',
            render: (text, record, index) => (
                record?.have_line_token === 1
                    ?
                    <Tag icon={<CheckCircleOutlined />} color="success">
                        已綁定
                    </Tag>
                    :
                    <Tag icon={<CloseCircleOutlined />} color="error">
                        未綁定
                    </Tag>

            )
        },
        {
            title: 'Line ID',
            key: 'custom_line_id',
            dataIndex: 'custom_line_id',
            align: 'center',
        },
        {
            title: 'Email',
            key: 'email',
            dataIndex: 'email',
            align: 'center',
        },

        {
            title: '地址',
            key: 'address',
            dataIndex: 'address',
            align: 'center',
        },
        {
            title: '最後編輯人',
            key: 'last_edit_user_name',
            dataIndex: 'last_edit_user_name',
            align: 'center',
        },
        {
            title: '最後編輯時間',
            key: 'last_edit_time',
            dataIndex: 'last_edit_time',
            align: 'center',
        },

        {
            title: '操作',
            key: 'operation',
            dataIndex: 'operation',
            align: 'center',
            sorter: false,
            render: (text, record, index) => (
                <>
                    <Button type="text" style={{ backgroundColor: "#fff8c8", color: "#000" }} onClick={(e) => { handleOnEditRow(record) }}>編輯</Button>
                    <Button type="text" style={{ color: '#5C88C5' }} onClick={(e) => showMessage("reset", [{ 'user_id': record.user_id }])}>重設密碼</Button>
                    <Button type="default" style={{ color: 'red' }} onClick={(e) => showMessage("delete", [{ 'user_id': record.user_id, 'staff_id': record.staff_id }])}>刪除</Button>
                </>
            )
        },
    ]
    const [default_column, set_default_column] = useState(defaultColumns);

    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.staff_id)
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.staff_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                select_temp.push(record.staff_id)
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record.staff_id)
                selectRow = selectRow.filter(row => row.staff_id !== record.staff_id)
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])

            }
            setModalLoading(false)
            setModalOpen(false)
        }
        else {
            if (axiosMode === "post") {
                message.error("新增失敗")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
                actionRef.current.reloadAndRest();
            }
            setModalLoading(false)
            setModalOpen(false)
        }
    }
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    }

    useEffect(() => {
        getData();
        getDepartmentData();
    }, [])

    useEffect(() => {
        getRoleData({
            // department_id_arr: departmentId.current
        })
    }, [
        // departmentId.current
    ])

    useEffect(() => {
        actionRef.current.reloadAndRest()
    }, [selectDepartmentId, selectRoleId])

    const handleOnEditRow = (record) => {
        form.resetFields()
        setAxiosMode("patch")
        setEditCard({});
        setTitle('修改人員');
        setColor('f09a45');
        setEdit(true);
        setOpen(true);
        setEditCard(record);
        form.setFieldsValue(record)
    }


    const changeDepartmentRole = (departmentRoleDataTemp) => {
        let departmentRoleDataResult = []
        // setDepartmentRoleData(
        departmentRoleDataResult = departmentRoleDataTemp.map((item, index) => {
            let departmentId = 0
            let roleId = 0
            departmentData.map((departmentDataItem, i) => {
                console.log(departmentRoleDataTemp)
                if (String(departmentDataItem.classify_structure_type_id) === String(item.department_classify_structure_type_id)) {
                    departmentId = departmentDataItem.department_id
                    roleData.map((roleDataItem, ii) => {
                        if (String(roleDataItem.classify_structure_type_id) === String(item.role_classify_structure_type_id)) {
                            roleId = roleDataItem.role_id
                        }
                    })
                }
            })
            return (
                {
                    department_id: departmentId,
                    role_id: roleId
                }
            )
        })
        return departmentRoleDataResult;
    }

    const onFormFinish = () => {
        const values = form.getFieldsValue()
        let departmentRoleData = []
        if (values.user_department_role_data) {
            departmentRoleData = changeDepartmentRole(values.user_department_role_data)
        }

        let datas = [{
            ...values,
            "name": values?.staff_name,
            "user_language_data": departmentRoleData
        }]
        if (axiosMode === "post") {
            postStaffData(datas)
        } else if (axiosMode === "patch") {
            patchStaffData(datas)
        }
    }

    const showMessage = (type, value) => {
        if (type === "reset") {
            confirm({
                title: '確定要重設密碼嗎',
                icon: <ExclamationCircleOutlined />,
                content: '密碼為0000',
                okText: '確定',
                okType: 'primary',
                cancelText: '取消',
                onOk() {
                    resetPassword(value);
                },
                centered: true
            });
        }
        else {
            confirm({
                title: '確定要刪除嗎',
                icon: <ExclamationCircleOutlined />,
                okText: '確定',
                okType: 'primary',
                cancelText: '取消',
                onOk() {
                    deleteUser(value);
                },
                centered: true
            });
        }
    }

    const resetPassword = (value) => {
        // console.log(value)
        // let data = [{ 'user_id': value }]
        axios
            .patch(`/organization_structure/api/user/reset_password`, value)
            .then((response) => {
                if (response.data.status !== 'success') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '重設密碼失敗',
                    });
                    reload();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '重設密碼成功',
                    });
                    reload();
                }
            })
    }
    const deleteUser = (value) => {
        deleteStaffData(value)
    }
    const handleOnDeleteRow = ({ val }) => {
        let deleterow = []
        if (val) {
            deleterow = [{
                staff_id: val?.staff_id,
                user_id: val?.user_id
            }]
        }

        else {
            deleterow = selectedRowsInfo.map((val) => {
                return {
                    staff_id: val?.staff_id,
                    user_id: val?.user_id
                }
            })
        }

        deleteStaffData(deleterow)
    }

    const getData = (param) => {
        if (staff_id !== null) {
            param = {
                ...param,
                staff_id: staff_id
            }
        }
        return axios
            .get('/organization_structure/api/staff', { params: param })
            .then((response) => {
                setData(response.data.data)
                set_total(response.data.total);
                return response.data
            })
    }

    const getDepartmentData = (params = {}) => {
        axios
            .get('/organization_structure/api/department', { param: params })
            .then((response) => {
                let tmp_data = response?.data?.data;
                setDepartmentOption(tmp_data?.map((item, item_index) => { return ({ label: item?.department_language_data?.find(item => item.language_culture_code === "zh-tw")?.language_culture_value || item.title, value: item.department_id }) }))
            })
        axios
            .get('/organization_structure/api/department', {
            })
            .then((response) => {
                console.log(response)
                setDepartmentData(response?.data?.data)
            })
    }

    const handleOnAddRow = () => {
        form.resetFields()
        setAxiosMode("post")

        setTitle('新增人員');
        setColor('d65b77');
        setEdit(false);
        setEditCard({});
        setOpen(true);
    }

    const reload = () => {
        set_force_reload(prev => prev + 1)
    }
    const onSuccess = () => {
        set_force_reload(prev => prev + 1)
        actionRef.current.reloadAndRest()
    }
    const onError = () => {
        set_force_reload(prev => prev + 1)
    }

    const DemoPie = (input = []) => {
        const data = input?.input;
        const config = {
            appendPadding: 10,
            data,
            angleField: 'value',
            colorField: 'type',
            radius: 0.9,
            label: {
                type: 'inner',
                offset: '-30%',
                content: ({ percent }) => `${(percent * 100).toFixed(0)}%`,
                style: {
                    fontSize: 15,
                    textAlign: 'center',
                },
            },
            interactions: [
                {
                    type: 'element-active',
                },
            ],
            style: { maxHeight: '20vh' },
        };
        return <Pie {...config} />;
    };

    const getRoleData = (params) => {
        axios
            .get('/organization_structure/api/role', {
                params
            })
            .then((response) => {
                let tmp_data = response?.data?.data;
                setRoleOption(tmp_data?.map((item, item_index) => { return ({ label: item?.role_language_data?.find(item => item.language_culture_code === "zh-tw")?.language_culture_value || item.title, value: item.role_id }) }))
                setRoleData(response?.data?.data)
            })
    }
    const { getStaffData, postStaffData, patchStaffData, deleteStaffData } = useStaff({ onBefore, onFinish })

    const {
        StaffStatisticsGenderData,
        getStaffStatisticsGenderData
    } = useStaffStatisticsGender({})

    const {
        StaffStatisticsDepartmentData,
        getStaffStatisticsDepartmentData
    } = useStaffStatisticsDepartment({})

    const {
        StaffStatisticsRoleData,
        getStaffStatisticsRoleData
    } = useStaffStatisticsRole({})

    const {
        DepartmentData,
        getDepartmentData: getDepartmentDatas
    } = useDepartment({})

    const {
        DepartmentDepthData,
        getDepartmentDepthData
    } = useDepartmentDepth({
        onBefore: () => {
            setLoading(true)
        },
        onFinish: ({ values }) => {
            let columns = [];
            values?.forEach(departmentDepth => {
                Object.entries(departmentDepth?.property_json)?.forEach(([property_json_key, property_json_value]) => {
                    columns.push({
                        title: property_json_key,
                        key: property_json_key,
                        dataIndex: property_json_key,
                        render: (text, record) => <>
                            {/* 拿個人部門 */}
                            {record?.user_department_role_data?.map(item => <>
                                {/* 篩選層級 */}
                                {item?.all_department_data?.filter(itemItem => itemItem?.depth === departmentDepth?.depth_id).map(itemItem => <>
                                    {/* 篩選屬性 */}
                                    <Row>
                                        <Col span={24}>
                                            <Tag color="geekblue">
                                                {itemItem?.property_json?.[property_json_key]}
                                            </Tag>
                                        </Col>
                                    </Row>
                                </>)}
                            </>)}
                        </>
                    })
                })
                columns.push({
                    title: departmentDepth?.depth_name,
                    key: departmentDepth?.depth_name,
                    dataIndex: departmentDepth?.depth_name,
                    render: (text, record) => <>
                        {/* 拿個人部門 */}
                        {record?.user_department_role_data?.map(item => <>
                            {/* 篩選層級 */}
                            {item?.all_department_data?.filter(itemItem => itemItem?.depth === departmentDepth?.depth_id).map(itemItem => <>
                                {/* 篩選語言 */}
                                {itemItem?.department_language_data?.filter(itemItemItem => itemItemItem.language_culture_code === "zh-tw").map(itemItemItem => <>
                                    <Row>
                                        <Col span={24}>
                                            <Tag color="geekblue">
                                                {itemItemItem?.language_culture_value}
                                            </Tag>
                                        </Col>
                                    </Row>
                                </>)}
                            </>)}
                        </>)}
                    </>
                })
                // })
                // columns.push({
                //     title: departmentDepth?.depth_name,
                //     key: departmentDepth?.depth_name,
                //     dataIndex: departmentDepth?.depth_name,
                // })
            })
            set_default_column([
                ...columns,
                ...defaultColumns
            ])
            setLoading(false)
        }
    })

    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
        transferColumnAntdToShadcn,
        transferSortAntdToShadcn
    } = useProTableOt({
        columns: default_column.concat(extra_columns || [])
    })
    useEffect(() => {
        checkAll()
        getStaffStatisticsGenderData()
        getStaffStatisticsDepartmentData()
        getStaffStatisticsRoleData()
        getDepartmentDatas({ classify_structure_type_id: 0, classify_structure_id: 9 })
    }, [])

    useEffect(() => {
        onSelect(selectedRowsInfo)
    }, [selectedRowsInfo])

    return (<>
        <LanguageContext.Provider vlaue={keyPrefix}>
            {/* <PersonalInformationModal
                openButtontext={"編輯"}
                title={"編輯資訊"}
                edit={edit}
                value={editcard}
                props_open={open}
                propsSetOpen={setOpen}
                onSuccess={onSuccess}
                onError={onError}
            /> */}
            <MainModal
                axiosMode={axiosMode}
                propsOpen={open}
                propsSetOpen={setOpen}

                propsForm={form}

                propsLoading={modalLoading}
                propsSetLoading={setModalLoading}

                onFinish={onFormFinish}
                formElement={<StaffForm
                    edit={edit}
                />}
                width={1000}
            />
        </LanguageContext.Provider>

        {show_tab_bar ?
            <Row>
                <Col>
                    <Tabs
                        items={[
                            {
                                key: undefined,
                                tab: '全部'
                            },
                            ...DepartmentData.map(item => (
                                {
                                    key: item.department_id,
                                    tab: item.department_language_data?.find(item => item.language_culture_code === "zh-tw")?.language_culture_value || item.title
                                }
                            ))]}
                        onChange={(departmentId) => {
                            tabDepartmentId.current = departmentId
                            if (departmentId === undefined) {
                                getDepartmentDepthData({ department_id: 0 })
                            } else {
                                getDepartmentDepthData({ department_id: departmentId })
                            }
                        }}
                    />
                </Col>
            </Row>
            : <></>}
        {show_chart ?
            <Row>
                <Col span={24}>
                    <BasicDataStats></BasicDataStats>
                </Col>
            </Row>
            : <></>}
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <WhiteBox>
                    {loading && <Skeleton />}
                    {!loading && <>
                        <ProTableOt
                            actionRef={actionRef}
                            columns={default_column}
                            check={check}
                            setCheck={setCheck}
                            rowKey={'staff_id'}
                            headerTitle={<>
                                {show_header_title ?
                                    <Row gutter={[8, 8]} justify={"end"}>
                                        <Col style={{ width: '200px' }}>
                                            <Select
                                                mode={"multiple"}
                                                allowClear={true}
                                                placeholder={"可選擇單位"}
                                                dropdownMatchSelectWidth={false}
                                                options={departmentOption}
                                                defaultValue={undefined}
                                                value={selectDepartmentId}
                                                onChange={(e) => {
                                                    setSelectDepartmentId(e);
                                                    if (e.length === 0) {
                                                        departmentId.current = undefined
                                                    } else {
                                                        departmentId.current = `{${e.join(',')}}`;
                                                    }
                                                }}
                                            >
                                            </Select>
                                        </Col>
                                        <Col style={{ width: '200px' }}>
                                            <Select
                                                mode={"multiple"}
                                                allowClear={true}
                                                placeholder={"可選擇職稱"}
                                                dropdownMatchSelectWidth={false}
                                                options={roleOption}
                                                defaultValue={undefined}
                                                value={selectRoleId}
                                                onChange={(e) => {
                                                    setSelectRoleId(e);
                                                    if (e.length === 0) {
                                                        roleId.current = undefined
                                                    } else {
                                                        roleId.current = `{${e.join(',')}}`;
                                                    }
                                                }}
                                            >
                                            </Select>
                                        </Col>
                                    </Row> : <></>}
                            </>}
                            request={async (params = {}, sort, filter) => {
                                // setAxiosMode("get")
                                let newParams = {
                                };
                                let order = setOrders(sort)
                                newParams = {
                                    ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                                    ...newParams,
                                    order,
                                    size: params.pageSize,
                                    cur_page: params.current,
                                    custom_filter_value: params.keyword ?? "",
                                    custom_filter_key: custom_filter_key,
                                    department_id_arr: departmentId.current || (tabDepartmentId.current ? `{${tabDepartmentId.current}}` : undefined),
                                    role_id_arr: roleId.current,
                                };
                                newParams = setParamsFilter({
                                    ...newParams,
                                });
                                // setPageSize(params?.pageSize ?? 20)

                                return getData({
                                    ...newParams
                                })
                            }}
                            toolBarRender={() => {
                                if (show_tool_bar) {
                                    return [
                                        <Button className='example' style={{
                                            backgroundColor: "#fff8c8",
                                            color: "#000"
                                        }}
                                            onClick={e => {
                                                handleOnAddRow()
                                            }}>
                                            新增人員
                                        </Button>,
                                        <Button className='example' style={{ backgroundColor: 'rgba(255, 242, 237, 1)', color: 'black' }} onClick={e => {
                                            confirm({
                                                title: '確定要刪除嗎',
                                                icon: <ExclamationCircleOutlined />,
                                                okText: '確定',
                                                okType: 'primary',
                                                cancelText: '取消',
                                                onOk() {
                                                    handleOnDeleteRow({});
                                                },
                                                centered: true
                                            });
                                        }}>
                                            <Row>
                                                <Col span={6}>
                                                    <img width="80%" src='/cram_school/error.png'></img>
                                                </Col>
                                                <Col span={18}>
                                                    <span>批次刪除</span>
                                                </Col>
                                            </Row>
                                        </Button>,
                                        <Button className='example' style={{ background: 'rgba(43, 193, 123, 1)', color: '#ffffff' }} onClick={e => { }}>匯出資料</Button>,
                                        <Button className='example' style={{ backgroundColor: '#41A084', color: '#FFFFFF' }} onClick={e => { }}>匯入資料</Button>,
                                        <Button className='example' style={{ backgroundColor: '#41A084', color: '#FFFFFF' }} onClick={e => { }}>基本資料欄位設定</Button>,
                                    ]
                                }
                                else {
                                    return [<></>]
                                }
                            }}
                            rowSelection={{
                                type: 'checkbox',
                                selectedRowKeys: selectedRowKeys,
                                setSelectedRowKeys: setSelectedRowKeys,
                                selectedRowsInfo: selectedRowsInfo,
                                setSelectedRowsInfo: setSelectedRowsInfo,
                                ...rowSelection,
                            }}
                            extra_columns={extra_columns}
                            set_extra_columns={set_extra_columns}
                            manage_columns={true}
                            scroll={{ x: 'max-content' }}
                        />
                    </>}
                </WhiteBox>
            </Col>
        </Row>
    </>)
}
export default Staff;

const setParamsFilter = (obj) => {
    return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
}

const WhiteBox = styled.div`
        background-color: #fff;
        padding: 1em;
        width: 100%;
        `

const StaffForm = ({
    mode = "modal",
    keyPrefix = "organization_structure.staff",
    /* 欄位標籤前置位置 */
    propsForm,
    /* 是否為parent物件控制form */
    formReloadCount = 0,
    /* 強制刷新的變數 */
    onFormFinish = () => { },
    /* 送出表單後的事件 */
    field,
    staff_id,
    is_disable,
    staff_self,
    ...props
}) => {
    const [columnRequires, setColumnRequires] = useState([])
    const [chagePassword, setChagePassword] = useState(false)
    const [form_] = Form.useForm();
    const form = propsForm || form_
    /* 表單物件宣告 */
    const keyPrefix_ = useContext(LanguageContext);
    /* 欄位標籤前置位置 */
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix_ || keyPrefix })
    /* 初始化語言呈現的位置，依照預設標籤位置、也可以引入標籤位置 */
    const setFormValuesOtherThings = (formValues) => {
        /* 設定form的數值 */
        //做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
        }
        /* 重新調整form的連動數值邏輯區域 */
        if (propsForm) {
            /* fom由paret進行控制 */
            propsForm.setFieldsValue(newFormValues)
            /* 設定parent form使用者輸入內容的值 */
        }
        else {
            form.setFieldsValue(newFormValues)
            /* 設定使用者輸入內容的值 */
        }
    }
    const setDataInitialization = () => {
        /* 設定初始化時要執行的業務邏輯 */
        getGenderData()
    }
    const onFinish = (values) => {
        /* form submit之後觸發事件 */
        onFormFinish({
            ...values,
        })
        /* 呼叫上層function */

    }
    const onValuesChange = () => {
        /* 取得被改變的欄位 */
        let formValues = null
        /* 現有使用者輸入內容初始化 */
        if (propsForm) {
            /* 判斷form的物件來源 */
            formValues = propsForm.getFieldsValue()
            /* 現在取得使用者輸入內容 */
        }
        else {
            formValues = form.getFieldsValue()
            /* 現在取得使用者輸入內容 */
        }
        // setFormValuesOtherThings(formValues)
    }

    const { GenderData, getGenderData } = useGender({})

    useEffect(() => {
        setDataInitialization();
    }, [])
    useEffect(() => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
    }, [formReloadCount])
    return <>
        <Form
            form={form}
            name="question"
            initialValues={{ remember: true }}
            onValuesChange={onValuesChange}
            onFinish={onFinish}
            // autoComplete="off"
            autoComplete="new-password"
        >
            {mode !== "information" && <>
                <Row gutter={[16, 16]}>
                    <Col span={mode === "modal" ? 0 : 8}>
                        {props.edit && <>
                            <Form.Item
                                label={"Line 綁定"}
                                name={"Line 綁定"}
                            >
                                <BindLineId />
                            </Form.Item>
                            <Form.Item
                                label={"修改密碼"}
                                name="status"
                            >
                                <Switch onChange={(res) => setChagePassword(res)} />
                            </Form.Item>
                        </>}
                        {chagePassword && props.edit && <>
                            <Form.Item
                                label={"舊密碼"}
                                name="old_password"
                                rules={[
                                    {
                                        required: true,
                                        message: `此為必填項目`
                                    }
                                ]}
                            >
                                <Input.Password autocomplete="new-password" />
                            </Form.Item>
                            <Form.Item
                                label={"修改密碼"}
                                name="password"
                                rules={[
                                    {
                                        required: true,
                                        message: `此為必填項目`
                                    }
                                ]}
                            >
                                <Input.Password autocomplete="new-password" />
                            </Form.Item>
                            <Form.Item
                                label={"再次輸入"}
                                name="password1"
                                dependencies={['password']}
                                hasFeedback
                                rules={[
                                    {
                                        required: true,
                                        message: '請確認新密碼',
                                    },
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            if (!value || getFieldValue('password') === value) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(new Error('兩次密碼不相同'));
                                        },
                                    }),
                                ]}

                            >
                                <Input.Password autocomplete="new-password" />
                            </Form.Item>
                        </>}
                    </Col>
                    <Col span={mode === "modal" ? 24 : 16}>
                        {props.edit &&
                            <Form.Item
                                label={"系統帳號"}
                                name="serial_name"
                                rules={[
                                    {
                                        required: columnRequires.includes("serial_name"),
                                        message: `此為必填項目`
                                    }
                                ]}
                            >
                                {/* <Tag bordered={false} color="processing"> */}

                                <Input bordered={false} disabled>
                                </Input>
                                {/* </Tag> */}
                            </Form.Item>
                        }

                        <Form.Item
                            name="staff_id"
                            hidden
                        >
                        </Form.Item>
                        <Form.Item
                            name="user_id"
                            hidden
                        >
                        </Form.Item>
                        <Form.Item
                            label={"人員編號"}
                            name="staff_serial_name"
                            rules={[
                                {
                                    required: columnRequires.includes("staff_serial_name"),
                                    message: `此為必填項目`
                                }
                            ]}
                        >
                            {/* <Tag bordered={false} color="processing"> */}

                            <Input bordered={false} >
                            </Input>
                            {/* </Tag> */}
                        </Form.Item>
                        <Form.Item
                            label={"姓名"}
                            name="staff_name"
                            rules={[
                                {
                                    required: columnRequires.includes("staff_name"),
                                    message: `此為必填項目`
                                }
                            ]}
                        >
                            <Input>
                            </Input>
                        </Form.Item>
                        <Form.Item
                            label={"英文姓名"}
                            name="staff_english_name"
                            rules={[
                                {
                                    required: columnRequires.includes("staff_english_name"),
                                    message: `此為必填項目`
                                }
                            ]}
                        >
                            <Input>
                            </Input>
                        </Form.Item>
                        <Form.Item
                            label={"性別"}
                            name="gender_id"
                            rules={[
                                {
                                    required: columnRequires.includes("gender_id"),
                                    message: `此為必填項目`
                                }
                            ]}
                        >
                            <Select
                                options={GenderData.map((value) => {
                                    return {
                                        label: value.gender_name,
                                        value: String(value.gender_id)
                                    }
                                })}
                            >
                            </Select>
                        </Form.Item>
                        <Form.List
                            label={"職位"}
                            name="user_department_role_data"
                            rules={[
                                {
                                    required: columnRequires.includes("department_role"),
                                    message: `此為必填項目`
                                }
                            ]}
                        >
                            {(fields, { add, remove }) => (<>
                                <Row gutter={[8, 8]} style={{ display: 'flex', justifyContent: 'end' }}>
                                    <Col span={16} >
                                        <Button
                                            style={{ width: '100%' }}
                                            onClick={
                                                () => {
                                                    add();
                                                }
                                            }>新增職位</Button>
                                    </Col>
                                    {fields?.map((field, key) => (<>
                                        <Col span={24}>
                                            <Form.Item
                                                label={`部門職位 - ${key + 1}`}
                                                name=""
                                                rules={[
                                                    {
                                                        required: columnRequires.includes(""),
                                                        message: `此為必填項目`
                                                    }
                                                ]}
                                            >
                                                {/* {} */}
                                                <DepartmentRole
                                                    key={field.id}
                                                    field={field}
                                                    remove={remove}
                                                    defaultDepartment={form.getFieldValue([field.name, "department_classify_structure_type_id"])}
                                                    defaultRole={form.getFieldValue([field.name, "role_classify_structure_type_id"])}
                                                ></DepartmentRole>
                                            </Form.Item>
                                        </Col>
                                    </>))}

                                </Row>

                            </>
                            )}
                        </Form.List>


                        <Form.Item
                            label={"Email"}
                            name="email"
                            rules={[
                                {
                                    required: columnRequires.includes("email"),
                                    message: `此為必填項目`
                                }
                            ]}
                        >
                            <Input autocomplete="new-password" />
                        </Form.Item>
                        <Form.Item
                            label={"Line ID"}
                            name="custom_line_id"
                            rules={[
                                {
                                    required: columnRequires.includes("custom_line_id"),
                                    message: `此為必填項目`
                                }
                            ]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label={"地址"}
                            name="address"
                            rules={[
                                {
                                    required: columnRequires.includes("address"),
                                    message: `此為必填項目`
                                }
                            ]}
                        >
                            <Input autocomplete="new-password" />
                        </Form.Item>
                    </Col>
                </Row>
                {mode === "modal" && <>
                    {props.edit && <>
                        <Form.Item
                            label={"Line 綁定"}
                            name={"Line 綁定"}
                        >
                            <BindLineId />
                        </Form.Item>
                        <Form.Item
                            label={"修改密碼"}
                            name="status"
                        >
                            <Switch onChange={(res) => setChagePassword(res)} />
                        </Form.Item>
                    </>}
                    {chagePassword && props.edit && <>
                        <Form.Item
                            label={"舊密碼"}
                            name="old_password"
                            rules={[
                                {
                                    required: true,
                                    message: `此為必填項目`
                                }
                            ]}
                        >
                            <Input.Password autocomplete="new-password" />
                        </Form.Item>
                        <Form.Item
                            label={"修改密碼"}
                            name="password"
                            rules={[
                                {
                                    required: true,
                                    message: `此為必填項目`
                                }
                            ]}
                        >
                            <Input.Password autocomplete="new-password" />
                        </Form.Item>
                        <Form.Item
                            label={"再次輸入"}
                            name="password1"
                            dependencies={['password']}
                            hasFeedback
                            rules={[
                                {
                                    required: true,
                                    message: '請確認新密碼',
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('password') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('兩次密碼不相同'));
                                    },
                                }),
                            ]}

                        >
                            <Input.Password autocomplete="new-password" />
                        </Form.Item>
                    </>}
                    <Form.Item
                        name={"property_json"}
                    >
                        <PropertyJson />
                    </Form.Item>
                </>}
            </>}
            {mode === "information" && <>
                <Form.Item
                    name={[field?.name ?? '', 'staff_id']}
                >
                    <StaffInformation
                        is_disable={is_disable}
                        staff_self={staff_self}
                        staff_id={staff_id}
                    />
                </Form.Item>
            </>}
        </Form >
    </>
}
export { StaffForm }

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);
function BasicDataStats() {
    // 模擬統計數據
    const totalUsers = 1000;
    const lineBoundUsers = 300;
    const qrCodeBoundUsers = 450;
    const unboundLineUsers = totalUsers - lineBoundUsers;
    const unboundQRCodeUsers = totalUsers - qrCodeBoundUsers;

    // Line 綁定與未綁定人數
    const lineChartData = {
        labels: ['已綁定', '未綁定'],
        datasets: [{
            label: 'Line 綁定狀況',
            data: [lineBoundUsers, unboundLineUsers],
            backgroundColor: ['rgba(54, 162, 235, 0.6)', 'rgba(255, 99, 132, 0.6)'],
            borderColor: ['rgba(54, 162, 235, 1)', 'rgba(255, 99, 132, 1)'],
            borderWidth: 1,
        }]
    };

    // QRCode 綁定與未綁定人數
    const qrCodeChartData = {
        labels: ['已綁定', '未綁定'],
        datasets: [{
            label: 'QRCode 綁定狀況',
            data: [qrCodeBoundUsers, unboundQRCodeUsers],
            backgroundColor: ['rgba(75, 192, 192, 0.6)', 'rgba(255, 159, 64, 0.6)'],
            borderColor: ['rgba(75, 192, 192, 1)', 'rgba(255, 159, 64, 1)'],
            borderWidth: 1,
        }]
    };

    // 總人數的條形圖
    const totalUsersChartData = {
        labels: ['總人數'],
        datasets: [{
            label: '基本資料維護總人數',
            data: [totalUsers],
            backgroundColor: 'rgba(153, 102, 255, 0.6)',
            borderColor: 'rgba(153, 102, 255, 1)',
            borderWidth: 1,
        }]
    };

    return (
        <Row>
            <Col
                xxl={8}
                xl={8}
                lg={8}
                md={8}
                sm={24}
                xs={24}
            >
                <h3>基本資料維護總人數</h3>
                <Bar data={totalUsersChartData} />
            </Col >
            {/* Line 綁定人數 */}

            <Col
                xxl={8}
                xl={8}
                lg={8}
                md={8}
                sm={24}
                xs={24}
            >
                <h3>Line 綁定人數</h3>
                <Pie data={lineChartData} />
            </Col >
            {/* QRCode 綁定人數 */}
            <Col
                xxl={8}
                xl={8}
                lg={8}
                md={8}
                sm={24}
                xs={24}
            >
                <h3>QRCode 綁定人數</h3>
                <Pie data={qrCodeChartData} />
            </Col >
        </Row>
    );
}


const StaffInformation = ({
    staff_id,
    value,
    is_disable = true,
    staff_self = false,
    onChange,
    onValuesChange
}) => {
    const { StaffData, getStaffData, getStaffSelfData } = useStaff({ onBefore: () => { }, onFinish: () => { } })
    useEffect(() => {
        if (staff_self) {
            getStaffSelfData({})
        } else {
            getStaffData({
                staff_id: staff_id ?? value
            })
        }
    }, [value, staff_id])
    const staff = StaffData?.find(_ => true) || {}
    return <>
        <FormContainer>
            <FormTitle>現在登入人員資訊</FormTitle>
            <FormField>
                <Label>姓名</Label>
                <Input type="text" value={staff?.staff_name} disabled={is_disable} />
            </FormField>
            <FormField>
                <Label>電子郵件</Label>
                <Input type="email" value={staff?.email} disabled={is_disable} />
            </FormField>
            <FormField>
                <Label>人員編號</Label>
                <Input type="text" value={staff?.serial_name} disabled={is_disable} />
            </FormField>
        </FormContainer>
    </>
}


// Styled Components
const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 400px;
    margin: 50px auto;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  `;

const FormTitle = styled.h2`
    margin-bottom: 20px;
    text-align: center;
    color: #333;
  `;

const FormField = styled.div`
    margin-bottom: 15px;
  `;

const Label = styled.label`
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
    color: #555;
  `;

